export const regExpPhone = /^[\d\s*#+()-]+$/;
export const regExpEmail = /^([\w\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,63}|[0-9]{1,2})(\]?)$/;
export const regExpNumber = /[+-]?([0-9]*[.])?[0-9]+/;
